import React from 'react';

const money = (value) =>
  new Intl.NumberFormat('es-AR', {
    style: 'currency',
    currency: 'ARS',
    maximumFractionDigits: 0,
  }).format(Number(value || 0));

export default function ProductSearch({
  inputRef,
  busqueda,
  setBusqueda,
  resultados,
  seleccion,
  cargando,
  onKeyDown,
  onAdd,
}) {
  return (
    <div className="relative mt-4">
      <div className="rounded-2xl bg-blanco-puro px-5 py-4 shadow-2xl">
        <label
          htmlFor="cantina-product-search"
          className="mb-1.5 block text-xs font-semibold text-azul-oscuro"
        >
          Buscar producto
        </label>

        <input
          id="cantina-product-search"
          ref={inputRef}
          autoFocus
          value={busqueda}
          onChange={(event) => setBusqueda(event.target.value)}
          onKeyDown={onKeyDown}
          placeholder="Nombre, código o código de barras..."
          className="h-12 w-full rounded-xl border-2 border-azul-lago bg-white px-4 text-base text-slate-800 outline-none transition focus:border-verde-esmeralda focus:ring-4 focus:ring-verde-esmeralda/20"
        />

        <p className="mt-2 text-xs text-slate-500">
          Escribí o escaneá. Presioná Enter para agregar.
        </p>
      </div>

      {busqueda && (
        <div className="absolute left-4 right-4 top-full z-30 mt-2 overflow-hidden rounded-xl border border-slate-200 bg-white shadow-2xl md:left-6 md:right-6">
          {cargando && (
            <div className="p-5 text-sm text-slate-500">
              Buscando...
            </div>
          )}

          {!cargando &&
            resultados.map((producto, index) => (
              <button
                type="button"
                key={producto.id}
                onMouseDown={(event) => event.preventDefault()}
                onClick={() => onAdd(producto)}
                className={`flex w-full items-center justify-between gap-4 border-b border-slate-100 px-4 py-3 text-left transition last:border-0 ${
                  index === seleccion
                    ? 'bg-verde-esmeralda text-white'
                    : 'bg-white hover:bg-slate-50'
                }`}
              >
                <div className="min-w-0">
                  <div
                    className={`text-sm font-semibold ${
                      index === seleccion
                        ? 'text-white'
                        : 'text-azul-oscuro'
                    }`}
                  >
                    {producto.nombre}
                  </div>

                  <div
                    className={`mt-0.5 text-[11px] ${
                      index === seleccion
                        ? 'text-white/80'
                        : 'text-slate-500'
                    }`}
                  >
                    {producto.codigo || 'Sin código'}
                    {' · '}
                    Stock {Number(producto.stock_actual)}
                  </div>
                </div>

                <div
                  className={`shrink-0 text-sm font-bold ${
                    index === seleccion
                      ? 'text-white'
                      : 'text-verde-oscuro'
                  }`}
                >
                  {money(producto.precio)}
                </div>
              </button>
            ))}

          {!cargando && resultados.length === 0 && (
            <div className="p-5 text-sm text-slate-500">
              No encontramos productos.
            </div>
          )}
        </div>
      )}
    </div>
  );
}
